import { pgEnum } from 'drizzle-orm/pg-core';
export const NumericType = pgEnum('numeric_type', [
    'integer',
    'decimal',
    'none',
]);
// Types of records that are managed internally — created programmatically rather
// than by a normal user action. Each value says why the row exists, which decides
// who should see it:
// - `cricket-bowling`: scaffolding for the bowling feature (exercises, metrics,
//   workout templates). Hidden from coach-facing library lists via
//   `getRecordTypeFilter` (see libs/trpc-server/src/lib/record-type-filter.ts).
// - `placeholder`: a row stamped only so ingested data has somewhere to land, with
//   no prescription of its own. Hidden from athletes, but shown to coaches — the
//   opposite polarity to `cricket-bowling`, so it is deliberately NOT in that
//   helper's internal list.
// A null record type means "normal" — created by a user, visible everywhere.
export const RecordTypes = ['cricket-bowling', 'placeholder'];
export const RecordType = pgEnum('record_type', RecordTypes);
// Source of truth for all metric types
export const MetricTypes = [
    'reps',
    'intensity',
    'rpe',
    'tempo',
    'sets',
    'custom',
];
export const MetricType = pgEnum('exercise_metric_type', MetricTypes);
export const TagType = pgEnum('tag_type', [
    'exercise',
    'workout_template',
    'metric_category',
]);
export const OneRepMaxFormula = pgEnum('one_rep_max_formula', [
    'epley',
    'brzycki',
    'lander',
    'lombardi',
    'mayhew',
    'oconner',
    'wathan',
]);
export const TaskStatus = pgEnum('task_status', [
    'pending',
    'in_progress',
    'completed',
    'failed',
    'canceled',
    // The message that should have started this task never reached its
    // worker (SC-5458): the task stays visible as a retryable failure.
    'send_failed',
]);
export const BlockStatus = pgEnum('block_status', ['planned', 'canceled']);
export const BlockType = pgEnum('block_type', ['strength_training', 'bowling']);
export const WorkoutStatus = pgEnum('workout_status', [
    'planned',
    'completed',
    'canceled',
    'skipped',
]);
export const WeightUnit = pgEnum('weight_unit', ['kg', 'lbs', 'oz', 'g']);
export const PhaseType = pgEnum('phase_type', [
    'preparation',
    'pre-season',
    'in-season',
    'post-season',
    'transition',
    'off-season',
]);
export const IntegrationPartners = ['eliteform', 'ams'];
export const IntegrationPartner = pgEnum('integration_partner', IntegrationPartners);
export const DefaultWeightUnits = ['lbs', 'kg'];
export const DefaultWeightUnit = pgEnum('default_weight_unit', DefaultWeightUnits);
// NOTE: When adding new roles, also update ProfileRoleType in @strength/server-auth
// (libs/server/auth/src/lib/server-auth.ts) to avoid circular dependencies.
export const ALL_ACCESS_PROFILE_ROLE = 'all-access';
export const TABLET_ONLY_PROFILE_ROLE = 'tablet-only';
export const CRICKET_BOWLING_COACH_PROFILE_ROLE = 'cricket-bowling-coach';
export const READ_ONLY_CORE_LIBRARY_PROFILE_ROLE = 'read-only-core-library';
export const TEAM_COACH_PROFILE_ROLE = 'team-coach';
export const COACH_PROFILE_ROLE = 'coach';
export const COACH_ADMIN_PROFILE_ROLE = 'coach-admin';
export const PERMISSION_DRIVEN_ROLES = [
    COACH_PROFILE_ROLE,
    COACH_ADMIN_PROFILE_ROLE,
];
export const ProfileRoleTypes = [
    ALL_ACCESS_PROFILE_ROLE,
    TABLET_ONLY_PROFILE_ROLE,
    CRICKET_BOWLING_COACH_PROFILE_ROLE,
    READ_ONLY_CORE_LIBRARY_PROFILE_ROLE,
    TEAM_COACH_PROFILE_ROLE,
    COACH_PROFILE_ROLE,
    COACH_ADMIN_PROFILE_ROLE,
];
export const ProfileRoleType = pgEnum('profile_role_type', ProfileRoleTypes);
export const DEFAULT_PROFILE_ROLE = ALL_ACCESS_PROFILE_ROLE;
export const PermissionScopes = ['org', 'team'];
export const PermissionScope = pgEnum('permission_scope', PermissionScopes);
export const AthleteTransferActions = ['team-added', 'team-removed'];
export const AthleteTransferActionEnum = pgEnum('transfer_action', AthleteTransferActions);
//# sourceMappingURL=enums.js.map